module.exports = __webpack_public_path__ + "img/gd.f06de1c7.svg";